import React from 'react';
import { XCircleIcon } from 'lucide-react';
const PAIN_POINTS = [{
  icon: '👻',
  text: 'Te dejan en visto justo después de dar el precio'
}, {
  icon: '🔄',
  text: 'Pasas horas explicando tu producto y nadie compra'
}, {
  icon: '😓',
  text: 'Sientes que "molestas" cuando haces seguimiento'
}, {
  icon: '📋',
  text: 'Respondes las mismas preguntas todos los días sin resultados'
}, {
  icon: '🥶',
  text: 'El cliente dice "lo voy a pensar" y desaparece para siempre'
}, {
  icon: '💸',
  text: 'Bajas el precio esperando que eso cierre la venta'
}];
export function PainPoints() {
  return <section className="bg-brand-white px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-85">
      <div className="mx-auto max-w-3xl" data-id="element-86">
        <div className="text-center mb-12" data-id="element-87">
          <p className="text-sm font-bold tracking-widest text-brand-green uppercase mb-4" data-id="element-88">
            ¿Te suena familiar alguna de estas situaciones?
          </p>
          <h2 className="text-3xl font-bold text-brand-black sm:text-4xl" data-id="element-89">
            Reconoces alguno de estos patrones:
          </h2>
        </div>

        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm mb-12" data-id="element-90">
          <div className="border-b border-gray-200 bg-gray-50 px-6 py-4 flex items-center gap-4" data-id="element-91">
            <XCircleIcon className="h-6 w-6 text-red-500" data-id="element-92" />
            <span className="font-bold text-gray-900" data-id="element-93">
              Lo que te está pasando ahora
            </span>
          </div>
          <ul className="divide-y divide-gray-100" data-id="element-94">
            {PAIN_POINTS.map((point, index) => <li key={index} className="flex items-center gap-4 px-6 py-5 hover:bg-gray-50 transition-colors" data-id="element-95">
                <span className="text-2xl" aria-hidden="true" data-id="element-96">
                  {point.icon}
                </span>
                <span className="text-lg font-medium text-gray-700" data-id="element-97">
                  {point.text}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="text-center bg-gray-50 rounded-xl p-8 border border-gray-100" data-id="element-98">
          <p className="text-xl font-bold text-brand-black mb-2" data-id="element-99">
            Si marcaste aunque sea UNO de estos, no es tu producto el problema.
          </p>
          <p className="text-2xl font-black text-brand-green" data-id="element-100">
            Es tu marco de conversación.
          </p>
        </div>
      </div>
    </section>;
}